import { render, staticRenderFns } from "./OrderDetailBox.vue?vue&type=template&id=234b6e72&scoped=true"
import script from "./OrderDetailBox.vue?vue&type=script&lang=js"
export * from "./OrderDetailBox.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailBox.vue?vue&type=style&index=0&id=234b6e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b6e72",
  null
  
)

export default component.exports